import React from "react";

const quotes = [
  {
    q: "Virarc took our brief and turned it into a home that genuinely works for the way our family lives. The attention to detail through documentation and on-site was exceptional.",
    by: "Sarah Whitmore",
    role: "Homeowner · Sydney, NSW",
  },
  {
    q: "From concept to handover, the team kept us informed and on programme. Our new headquarters came in on budget and looks remarkable.",
    by: "James O'Connor",
    role: "Managing Director, Vellum Co. · Melbourne, VIC",
  },
  {
    q: "We've worked with a lot of building consultants. Virarc is the only one that handles design, drafting and construction without anything getting lost in translation.",
    by: "Priya Raman",
    role: "Property Developer · Brisbane, QLD",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="section-testimonials" className="bg-bone py-24 md:py-40">
      <div className="w-full max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-12 gap-8 mb-16 reveal">
          <p className="label col-span-12 md:col-span-2">07 — Client voices</p>
          <h2 className="display col-span-12 md:col-span-9 text-[9vw] md:text-6xl lg:text-[5rem] leading-[0.98] tracking-tighter">
            Trusted by people who <span className="italic font-light text-rust">don{`'`}t accept</span> second best.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-ink/15">
          {quotes.map((q, i) => (
            <figure key={i} data-testid={`testimonial-${i}`} className="reveal bg-bone p-8 md:p-12 relative">
              <span className="display italic text-clay text-7xl leading-none absolute top-6 right-8 opacity-40">“</span>
              <blockquote className="display italic text-2xl md:text-[1.7rem] leading-snug text-ink relative z-10">
                {q.q}
              </blockquote>
              <figcaption className="mt-10 pt-6 border-t border-ink/10">
                <p className="font-body text-base">{q.by}</p>
                <p className="label mt-1">{q.role}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
